/**
 * 文件下载
 * @param file
 */
export function downLoadFile(file={url: '',name: ''}) {
    let link = document.createElement('a');
    let url = file.url
    // 这里是将url转成blob地址，
    fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        link.href = URL.createObjectURL(blob)
        link.download = file.name//为空使用下载名称
        document.body.appendChild(link)
        link.click()
    })

}